<i18n src="../../locales/lang.json"></i18n>

<template>
  <div v-bind:class="{show : isvisible == true, displayblock : isvisible == true}" class="modal" tabindex="-1" v-bind:id="'modal' + getId()" role="dialog">
    <div class="modal-dialog" v-bind:class="size" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{title}}</h5>
          <button type="button" class="close"  @click="close()">&times;</button>
        </div>

        <div class="modal-body">
          <slot></slot>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-link" @click="doClose()">{{closebuttontext}}</button>
          <!--<button type="button" class="btn skin primary-button" @click="doSave1()">{{button1text}}</button>-->
          <div class="btn-group show ml-2">
            <button type="button" class="btn skin primary-button dropdown-toggle" data-toggle="dropdown" aria-expanded="true"> {{button3text}}</button>
            <div v-if="onsave_button3 != null" class="skinnedmenu dropdown-menu dropdown-menu-right" x-placement="bottom-end" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(-38px, 35px, 0px);">
              <a href="#" class="dropdown-item" @click="doSave2()">{{button2text}}</a>
              <a href="#" class="dropdown-item" @click="doSave3()">{{button3text}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'testcomponent',
    components: {
    },
    props: {
      title: {
        required: false,
        type: String,
        default: null
      },
      onclose: {
        required: false,
        type: Function,
        default: null
      },
      onsave_button1: {
        required: false,
        type: Function,
        default: null
      },
      onsave_button2: {
        required: false,
        type: Function,
        default: null
      },
      onsave_button3: {
        required: false,
        type: Function,
        default: null
      },
      show: {
        required: false,
        type: String,
        default: null
      },
      closebuttontext: {
        required: false,
        type: String,
        default: null
      },
      button1text: {
        required: false,
        type: String,
        default: null
      },
      button2text: {
        required: false,
        type: String,
        default: null
      },
      button3text: {
        required: false,
        type: String,
        default: null
      },
      size: {
        required: false,
        type: String,
        default: null
      },
    },
    data() {
      return {
        isvisible: this.show == "true"
      }
    },
    methods: {
      getId() {
        return this._uid;
      },
      open() {
        this.isvisible = true;
        //$('modal' + getId()).modal();
      },
      close() {
        this.isvisible = false;

      },
      doClose() {
        //if (this.onclose != null) {
        //  this.onclose();
        //}
        //else
        //  close();
        this.close();
        if (this.onclose != null) {
          this.onclose();
        }
      },
      doSave1() {
        if (this.onsave_button1 != null) {
          this.onsave_button1();
        }
      },
      doSave2() {
        if (this.onsave_button2 != null) {
          this.onsave_button2();
        }
      },
      doSave3() {
        if (this.onsave_button3 != null) {
          this.onsave_button3();
        }
      }
    },
    created() {

    },
    mounted() {

      $('body').append($(this.$el).detach());

      if (this.closebuttontext == null)
        this.closebuttontext = this.$t('cancel');
      //if (this.button1text == null)
      //  this.button1text = this.$t('save_and_assign');
      if (this.button2text == null)
        this.button2text = this.$t('save_and_assign');
      if (this.button3text == null)
        this.button3text = this.$t('save');
      
      
    }
  }
</script>

<style scoped>
  .displayblock {
    display:block;
  }

  @media (max-width: 768px) {
    .modal {
      width: 100%;
      max-width: 100%;
      height: 100vh;
      margin: 0;
      min-height: 100vh;
    }

    .modal-dialog {
      margin: 0 !important;
      padding: 0px !important;
      height: 100vh;
    }

    .modal-body {
      height: calc(-105px + 100vh);
    }

    .modal-content {
      height: calc(100vh - 170px) !important;
      flex: none !important;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/modals/modal-three-buttons.vue